import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private storage: Storage
  private prefix: string = 'sispg_'

  constructor() {
    this.storage = window.localStorage
  }

  hasStorage(): boolean {
    return !!this.storage
  }

  set(key: string, value: any): boolean {
    if (this.storage) {
      this.storage.setItem(this.prefix + key, JSON.stringify(value))
      return true
    }
    return false
  }

  get(key: string): any {
    if (this.storage) {
      const data = this.storage.getItem(this.prefix + key)
      return data !== undefined && data !== null && data !== 'undefined' ? JSON.parse(data) : null
    }
    return null
  }

  remove(key: string): boolean {
    if (this.storage) {
      this.storage.removeItem(this.prefix + key)
      return true
    }
    return false
  }

  getLocallyStored<T>(objPrefix: string, obj: T): LocallyStored<T> {
    return new LocallyStored(this, objPrefix, obj)
  }
}

export class LocallyStored<T> {
  private protertyNames: (keyof T)[]

  constructor(
    private localStorageService: LocalStorageService,
    private objPrefix: string,
    obj: T
  ) {
    this.protertyNames = Object.getOwnPropertyNames(obj) as (keyof T)[]
  }

  getStoredObj(): T {
    let obj = {} as T

    for (let key of this.protertyNames) obj[key] = this.get(key)

    return obj
  }

  updateStoredObj(obj: Partial<T>) {
    Object.entries(obj).forEach(([key, value]) => {
      if (key && value != null) this.set(key as keyof T, value)
      else this.remove(key as keyof T)
    })
  }

  deleteStoredObj() {
    if (!this.localStorageService.hasStorage()) return false

    for (let key of this.protertyNames) this.remove(key)

    return true
  }

  get(key: keyof T) {
    return this.localStorageService.get(this.objPrefix + (key as string))
  }

  set(key: keyof T, value: any) {
    return this.localStorageService.set(this.objPrefix + (key as string), value)
  }

  remove(key: keyof T) {
    return this.localStorageService.remove(this.objPrefix + (key as string))
  }
}
